import { z } from "zod"
import { baseSchema, schemaToJson } from "../schema-utils.js"

const DbPublisherSchema = z.strictObject({
  ...baseSchema.shape,
  url: z.string(),
  dc_title: z.string().nullable(),
  dc_description: z.string().nullable(),
  logo_url: z.string().nullable(),
  image_url: z.string().nullable(),
  user_id: z.string().nullable(),
  dc_created_at: z.date().nullable(),
  tags: z.string().nullable(),
})
export type DbPublisher = z.infer<typeof DbPublisherSchema>

export const PublisherSchema = schemaToJson(DbPublisherSchema)
export type Publisher = z.infer<typeof PublisherSchema>
